import request from 'api/request';

export default function callTicketRoute(id) {
  return request({ url: `/tickets/${id}/call`, method: 'POST' });
}
